import {Component, Inject, OnInit} from '@angular/core';
import {Validators, UntypedFormBuilder} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PlatformService} from 'src/app/core/services/api/platform.service';
import {ProgramService} from 'src/app/core/services/api/program.service';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { PlatformMedia } from 'src/app/core/contracts/models/medio-plataformas';
import { ProgramPlatform } from 'src/app/core/contracts/models/program-platform';
import Swal from 'sweetalert2';
import { Observable, forkJoin, of } from 'rxjs';

@Component({
    selector: 'app-asignar-programas-link',
    templateUrl: './asignar-programas-link.component.html',
    styleUrls: ['./asignar-programas-link.component.scss']
})
export class AsignarProgramasLinkComponent implements OnInit {

    myForm = this.formBuilder.group({
        platform: ['', Validators.required],
        value: ['', Validators.required],
        alcance: ['', Validators.required]
    });

    id: any;
    public loading: boolean = false;
    dataForm: ProgramPlatform = {
        id: null,
        programa_id: null,
        idMedioPlataforma: null,
        valor: null,
        alcance: null
    }

    buttonSubmit = true;
    title = 'Agregar plataforma  al programa: ';
    messages = {emptyMessage: 'No hay información para mostrar.'};

    platforms: PlatformMedia[] = [];
    rows: ProgramPlatform[] = [];

    /** Tipo de valorización de la plataforma seleccionada */
    tipoValorizacion: string | null = null;

    isLoading = true;

    addPermission = this.auth.isPermit('medio.programa-plataforma.add');
    editPermission = this.auth.isPermit('medio.programa-plataforma.edit');
    deletePermission = this.auth.isPermit('medio.programa-plataforma.delete');
    
    userIsAdmin: boolean = this.auth.isAdmin;
    userIsAgent: boolean = this.auth.isAgent;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private platformService: PlatformService,
        private programService: ProgramService,
        public dialogRef: MatDialogRef<AsignarProgramasLinkComponent>,
        // local: el programa aún no existe; el modal devuelve la plataforma en vez de guardarla
        // (pending: plataforma local a editar, assignedIds: plataformas ya agregadas a la lista)
        @Inject(MAT_DIALOG_DATA) public data: { row: any, id: number, medio_id: number, local?: boolean, pending?: any, assignedIds?: number[] },
        private auth: AuthService,
        private swal: Swal2
    ) {
    }

    ngOnInit(): void {
        // console.log(this.data.id);
        // console.log(this.data);

        const platforms$ = this.platformService.getListByMedio(this.data.medio_id);
        const programaPlataforma$ = this.data.row
            ? this.programService.getIdProgramaPlataforma(this.data.row.id)
            : of(null);

        if (this.data.row) {
            this.title = `Editar plataforma del programa: ${this.data.row.programa.nombre}`;
        }

        if (this.data.local) {
            this.title = this.data.pending ? 'Editar plataforma del programa' : 'Agregar plataforma al programa';
        }

        forkJoin([platforms$, programaPlataforma$]).subscribe(([platResponse, progResponse]: [any, any]) => {
            // Cargar plataformas
            this.platforms = platResponse.medioPlataformas;

            // Modo local: se ocultan las plataformas que ya están en la lista y se precarga la editada
            if (this.data.local) {
                const assigned = this.data.assignedIds ?? [];
                this.platforms = this.platforms.filter(pl => !assigned.includes(pl.id));
                const pending = this.data.pending;
                if (pending) {
                    this.myForm.get('platform').setValue(pending.idMedioPlataforma);
                    this.myForm.get('value').setValue(pending.valor);
                    this.myForm.get('alcance').setValue(pending.alcance);
                    this.myForm.get('platform').disable();
                    this.tipoValorizacion = pending.medio_plataforma?.plataforma_clasificacion?.plataforma?.tipo_valorizacion ?? null;
                }
                return;
            }

            // Modo edición
            if (progResponse) {
                const pp = progResponse['data'];
                // console.log('response', progResponse);
                // console.log('data', pp);

                this.id = pp.id;
                this.myForm.get('value').setValue(Number(pp.valor));
                this.myForm.get('platform').setValue(pp.idMedioPlataforma);
                this.myForm.get('alcance').setValue(Number(pp.alcance));
                this.myForm.get('platform').disable();

                // Con ambas llamadas resueltas, tipoValorizacion se setea correctamente
                const found = this.platforms.find(pl => pl.id == pp.idMedioPlataforma);
                this.tipoValorizacion = found?.plataforma_clasificacion?.plataforma?.tipo_valorizacion ?? null;
            }
        });
    }

    getAll() {
        this.programService.getAllProgramaPlataformas(this.data.id).subscribe((response: any) => {
            this.rows = response.data.map(row => ({
                ...row,
                alcance: row.alcance || 0 // Aseguramos que siempre haya un valor
            }));
            this.isLoading = false;
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 200);
        });
    }

    onSubmit() {
        this.buttonSubmit = false;
        if (this.myForm.invalid) {
            this.buttonSubmit = true;
            return;
        }

        if (this.data.local) {
            const idMedioPlataforma = this.myForm.get('platform').value;
            this.dialogRef.close({
                idMedioPlataforma,
                valor: this.myForm.get('value').value,
                alcance: this.myForm.get('alcance').value || 0,
                // Misma forma que devuelve la API para reutilizar la tabla de plataformas
                medio_plataforma: this.platforms.find(pl => pl.id == idMedioPlataforma),
            });
            return;
        }

        this.dataForm.valor = this.myForm.get('value').value;
        this.dataForm.programa_id = this.data.id;
        this.dataForm.idMedioPlataforma = this.myForm.get('platform').value;
        this.dataForm.alcance = this.myForm.get('alcance').value || 0 ;
        let observable: Observable<any> | undefined = undefined;
        if (this.id) {
            this.dataForm.id = this.id;
            observable = this.programService.updateProgramaPlataformas(this.dataForm)
            // .subscribe((response: any) => {
            //     this.getAll();
            //     this.myForm.reset();
            //     Object.keys(this.myForm.controls).forEach(control => {
            //         this.myForm.get(control).setErrors(null);
            //     });
            //     this.id = null;
            //     this.myForm.get('platform').enable();
            //     this.swal.showToast(response.message, 'success');
            //     this.buttonSubmit = true;
            // }, error => {
            //     if (error.status === 400) {
            //         this.error(error);
            //     }
            //     this.buttonSubmit = true;
            // });

        } else {
            observable = this.programService.createProgramaPlataformas(this.dataForm)
            // .subscribe((response: any) => {
            //     this.getAll();
            //     this.myForm.reset();
            //     Object.keys(this.myForm.controls).forEach(control => {
            //         this.myForm.get(control).setErrors(null);
            //     });
            //     this.swal.showToast(response.message, 'success');
            //     this.buttonSubmit = true;
            // }, error => {
            //     if (error.status === 400) {
            //         this.error(error);
            //     }
            //     console.warn(error);
            //     this.buttonSubmit = true;
            // });
        }

        observable.subscribe((response: any) => {
            this.dialogRef.close(response);
            // this.getAll();
            this.myForm.reset();
            Object.keys(this.myForm.controls).forEach(control => {
                this.myForm.get(control).setErrors(null);
            });
            this.swal.showToast(response.message, 'success');
            this.buttonSubmit = true;
        }, error => {
            // if (error.status === 422) {
                this.error(error);
            // }
            console.warn(error);
            this.buttonSubmit = true;
        });
    }

    error(error) {
        if (error.error.errors.idMedioPlataforma) {
            this.swal.showToast(error.error.errors.idMedioPlataforma[0], 'error');
        }
    }

    delete(id: number) {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#645CAA',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.programService.deleteProgramaPlataformas(id).subscribe({
                    next: (response: any) => {
                        Swal.fire({
                            title: 'Eliminado',
                            text: 'El programa se ha eliminado correctamente',
                            icon: 'success',
                            confirmButtonColor: '#645CAA',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.getAll();
                        });
                    },
                    error: (error) => {
                        Swal.fire({
                            title: 'Error',
                            text: error.error.message || 'Ha ocurrido un error',
                            icon: 'error',
                            confirmButtonColor: '#645CAA',
                            confirmButtonText: 'OK'
                        });
                    }
                });
            }
        });
    }

    edit(row: ProgramPlatform) {
        // console.log(row);
        
        this.id = row.id;
        this.myForm.get('value').setValue(Number(row.valor));
        this.myForm.get('platform').setValue(row.idMedioPlataforma);
        this.myForm.get('alcance').setValue(Number(row.alcance));
        this.myForm.get('platform').disable();
    }

    cancelEdit() {
        this.id = null;
        this.myForm.markAllAsTouched();
        this.myForm.reset();
        this.myForm.get('platform').enable();
    }

    cancel() {
        this.dialogRef.close();
    }

    onChangeSelect() {
        const find = this.platforms.find(pl => pl.id == this.myForm.get('platform').value);
        if (find) {
            if (find.valorizacion_plataforma) {
                this.myForm.get('value').setValue(Number(find.valorizacion_plataforma));
            }
            if (find.alcance) {
                this.myForm.get('alcance').setValue(Number(find.alcance));
            }
            this.tipoValorizacion = find.plataforma_clasificacion?.plataforma?.tipo_valorizacion ?? null;
        } else {
            this.tipoValorizacion = null;
        }
    }
}